module.exports = __webpack_public_path__ + "img/clack.94c4b937.png";